// "common" is the sentinel first label for Studio's tenant-agnostic root address
// (e.g. "common.studio.eu.mambu.com" — the fixed host CBE's studioUrl always
// points at, regardless of tenant). Everywhere else, the first label is the
// tenant id (e.g. "acme.studio.eu.mambu.com" -> "acme"). A bare host with no
// subdomain at all (e.g. "localhost") also has no tenant.
const ROOT_LABEL = 'common'

// A bare IPv4 literal (e.g. "127.0.0.1") splits into four numeric "labels" on
// '.', which would otherwise be mistaken for a tenant subdomain host.
const IPV4_RE = /^\d{1,3}(\.\d{1,3}){3}$/

export function getTenantFromHostname(hostname: string = window.location.hostname): string {
  if (IPV4_RE.test(hostname)) return ''
  const [first, ...rest] = hostname.split('.')
  if (rest.length === 0 || first === ROOT_LABEL) return ''
  return first
}

// Studio's own subdomain for a tenant. When baseDomain is provided (e.g.
// "studio.dev.mambucloud.com" from BASE_STUDIO_URL), the URL is built directly
// as "{tenantId}.{baseDomain}" — no hostname-label stripping needed. Falls back
// to hostname-label stripping (replacing the first label with the tenant id) for
// local dev where BASE_STUDIO_URL is unset.
export function buildTenantStudioUrl(
  tenantId: string,
  location: Location = window.location,
  baseDomain?: string | null,
): string {
  const port = location.port ? `:${location.port}` : ''
  if (baseDomain) {
    return `${location.protocol}//${tenantId}.${baseDomain}${port}`
  }
  const [first, ...rest] = location.hostname.split('.')
  const labels = rest.length === 0 ? [tenantId, first] : [tenantId, ...rest]
  return `${location.protocol}//${labels.join('.')}${port}`
}
